import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";

import { DialogFooter } from "../../components/DialogFooter";
import { LoadingButton } from "../../components/LoadingButton";

interface RemoveLicenseBottomSheetProps {
  modalState: UseModalState;
  onRemoveLicense: () => Promise<void>;
  isRemovingLicense: boolean;
}

export function RemoveLicenseBottomSheet(props: RemoveLicenseBottomSheetProps) {
  const { modalState, onRemoveLicense, isRemovingLicense } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter
          orientation="vertical"
          onClose={() => {
            modalState.closeModal();
          }}
        >
          <LoadingButton
            fullWidth
            variant="destructive"
            size="large"
            isLoading={isRemovingLicense}
            onClick={async () => {
              await onRemoveLicense();
            }}
          >
            Remove license
          </LoadingButton>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="document-rejected"
        title="Remove this license?"
        description="If you remove this license now, you'll need to reupload it again in the future"
      />
    </BottomSheet>
  );
}
